exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-peer-review.js-WebpackMultiOutput";